// extracted by mini-css-extract-plugin
module.exports = {"logoWithBorder":"styles_logoWithBorder__nxFk0","logosContainer":"styles_logosContainer__khm9q","logo":"styles_logo__baRYn"};